import request from 'sb-request'
import actions from 'redux/actions'
import { getState } from 'redux/core'
import { constants, links } from 'common/helpers'
import { getCookieValue } from 'helpers'


const _subscribeToStockNotification = (productId) =>
  request.post(`rest/product/${productId}/notify-out-of-stock`, {
    withErrorModal: false,
  })
    .then(
      () => actions.misc.notifications.show('OutOfStockSubscription'),
      ({ error, message }) => {
        if (error === 'product_already_in_out_of_stock_notification') {
          actions.misc.notifications.show('OutOfStockSubscription')
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            content: message,
          })
        }
      }
    )

const moveStockNotificationFromCookieToStorage = () => {
  const productId = getCookieValue(constants.cookieNames.postponed.stockNotificationSubscriptionProductId)

  if (productId) {
    actions.misc.localStorage.setItem(constants.localStorageNames.stockNotificationSubscriptionProductId, productId)
    actions.misc.cookies.removeItem(constants.cookieNames.postponed.stockNotificationSubscriptionProductId)
  }
}

const subscribeToStockNotification = (productId) => {
  const { models: { me: { isLoggedIn } } } = getState()

  if (!isLoggedIn) {
    actions.misc.localStorage.setItem(constants.localStorageNames.stockNotificationSubscriptionProductId, productId)
    actions.models.modals.close(constants.modals.ProductDetails)
    actions.models.router.push(links.register)

    return Promise.resolve()
  }

  return _subscribeToStockNotification(productId)
}

const resolvePostponedStockNotificationSubscription = () => {
  const productId = actions.misc.localStorage.getItem(constants.localStorageNames.stockNotificationSubscriptionProductId)

  if (!productId) {
    return Promise.resolve()
  }

  actions.misc.localStorage.removeItem(constants.localStorageNames.stockNotificationSubscriptionProductId)

  return _subscribeToStockNotification(productId)
}


export default {
  subscribeToStockNotification,
  moveStockNotificationFromCookieToStorage,
  resolvePostponedStockNotificationSubscription,
}
